import React, { useState, useEffect } from 'react';
import api from '../../../api';
import styles from './SendPushNotifications.module.css';
import SendPushNotificationFilter from './SendPushNotificationFilter/SendPushNotificationFilter';
import DropdownSelector from '../DropdownSelector/DropdownSelector';
import Loader from '../../../campaigns/components/Loader/Loader';

const pushNotificationTemplates = [
  {
    label: 'Nieuwe BUFFL survey beschikbaar! 🐃',
    value: {
      title: 'Nieuwe BUFFL survey beschikbaar! 🐃',
      description: 'Laat jouw mening weten en verdien tokens! 💌'
    }
  },
  {
    label: 'Give us your opinion...',
    value: {
      title: 'Give us your opinion...',
      description: 'About BUFFL! 😅'
    }
  },
  {
    label: 'We want to hear what you think! 👂',
    value: {
      title: 'We want to hear what you think! 👂',
      description: 'Go to the BUFFL app 😉!'
    }
  },
  {
    label: 'Got a moment? ⌛',
    value: {
      title: 'Got a moment? ⌛',
      description: 'There is a new survey ready for you! 🌅'
    }
  }
];

const PushNotificationsCenter = props => {
  const {
    filterConfiguration,
    FILTER_CONSTANTS,
    activeFilters,
    setActiveFilters,
    isListFetching,
    pushNotifications,
    setPushNotifications,
    pushNotificationToSendAgain,
    setPushNotificationToSendAgain,
    setPushNotificationDetails
  } = props;

  const [pushNotificationProps, setPushNotificationProps] = useState({
    title: '',
    description: ''
  });
  const [sendingPushNotification, setSendingPushNotification] = useState(false);
  const [requestCompletedStatus, setRequestCompletedStatus] = useState(null);

  useEffect(
    () => {
      if (
        pushNotificationToSendAgain &&
        pushNotificationToSendAgain.attributes
      ) {
        setPushNotificationProps({
          title: pushNotificationToSendAgain.attributes.title,
          description: pushNotificationToSendAgain.attributes.description
        });

        if (pushNotificationToSendAgain.attributes.filter_string) {
          setActiveFilters(
            JSON.parse(pushNotificationToSendAgain.attributes.filter_string)
          );
        }
      }
    },
    [pushNotificationToSendAgain]
  );

  useEffect(
    () => () => {
      setPushNotificationProps({
        title: '',
        description: ''
      });

      setActiveFilters([]);
      setPushNotificationToSendAgain({});
    },
    []
  );

  const allowedToSendPush = () => {
    if (
      pushNotificationProps &&
      pushNotificationProps.title !== '' &&
      pushNotificationProps.description !== '' &&
      pushNotificationProps.title.length < 40
    ) {
      return true;
    }
    return false;
  };

  const sendPushNotification = () => {
    const sendPushNotificationApi = async () => {
      const activeFiltersWithValue = activeFilters.filter(filter => {
        if (filter.name === '') return false;
        if (Array.isArray(filter.values)) {
          return !!filter.values.length;
        }
        if (Object.keys(filter.values).length) return true;
        return null;
      });
      setSendingPushNotification(true);
      const newPushNotification = await api().sendPushNotification(
        pushNotificationProps,
        activeFiltersWithValue
      );
      if (
        newPushNotification &&
        newPushNotification.json &&
        newPushNotification.json.pushNotification
      ) {
        const newPushNotificationFormatted = {
          attributes: {
            count: newPushNotification.json.pushNotification.count,
            createdAt: newPushNotification.json.pushNotification.createdAt,
            description: newPushNotification.json.pushNotification.description,
            filter_string:
              newPushNotification.json.pushNotification.filter_string,
            title: newPushNotification.json.pushNotification.title,
            servicePushIds:
              newPushNotification.json.pushNotification.servicePushIds
          }
        };
        setPushNotifications([
          ...[newPushNotificationFormatted],
          ...pushNotifications
        ]);
        setPushNotificationDetails(newPushNotificationFormatted);
        setRequestCompletedStatus(true);
      } else {
        setRequestCompletedStatus(false);
      }
      setSendingPushNotification(false);
    };

    sendPushNotificationApi();
  };

  if (requestCompletedStatus === true || requestCompletedStatus === false) {
    return (
      <div className={styles.sendPushContainer}>
        <div className={styles.title}>Send Push Notification</div>
        <div className={styles.inputContainer}>
          {requestCompletedStatus === true
            ? 'Push Sent Sucessfully'
            : 'Error occured. Please contact administrator'}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.sendPushContainer}>
      <div className={styles.title}>
        Send Push Notification
        <DropdownSelector
          options={pushNotificationTemplates}
          value={{}}
          filterDropdownStyle={styles.filterDropdownStyle}
          placeholder="Select from template"
          popupAlign="right"
          onSelectCompleted={value =>
            setPushNotificationProps({
              title: value.title,
              description: value.description
            })
          }
        />
      </div>
      <div className={styles.inputContainer}>
        <input
          className={styles.input}
          placeholder="Title"
          value={pushNotificationProps.title}
          onChange={e =>
            setPushNotificationProps({
              ...pushNotificationProps,
              ...{ title: e.target.value }
            })
          }
        />
        <input
          className={styles.input}
          placeholder="Description"
          value={pushNotificationProps.description}
          onChange={e =>
            setPushNotificationProps({
              ...pushNotificationProps,
              ...{ description: e.target.value }
            })
          }
        />
      </div>
      <SendPushNotificationFilter
        filterConfiguration={filterConfiguration}
        FILTER_CONSTANTS={FILTER_CONSTANTS}
        activeFilters={activeFilters}
        setActiveFilters={setActiveFilters}
      />
      {sendingPushNotification ? <Loader /> : null}
      {!isListFetching && !sendingPushNotification ? (
        <div className={styles.footerContainer}>
          <div
            className={
              allowedToSendPush()
                ? `${styles.sendPushButton}`
                : `${styles.sendPushButton} ${styles.sendPushButtonDisabled}`
            }
            role="presentation"
            onClick={() => {
              if (
                pushNotificationProps.title &&
                pushNotificationProps.description &&
                allowedToSendPush()
              ) {
                sendPushNotification();
              }
            }}
          >
            Send push notification
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default PushNotificationsCenter;
